import { QuoteComparisonAnimation } from '@/components/quotes/QuoteComparisonAnimation/QuoteComparisonAnimation'
import { Button } from '@/components/ui/button'

/**
 * The Insurance tab for a fleet that has not bought insurance. Shows the quotes
 * screen running rather than describing it — the same argument the marketing
 * loop makes, put where someone arrives expecting a policy and has none.
 */
export function InsuranceBlankState() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-6">
      {/* The loop scales to its container, so capping the width is what sizes it:
          full width it swallowed the page and left no room for the ask. */}
      <QuoteComparisonAnimation className="w-full max-w-[420px]" />
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-ink text-xl font-bold tracking-tight">See what your fleet would pay</h1>
        <p className="text-ink-500 max-w-sm text-sm leading-relaxed">
          Quotes from the carriers that write for fleets your size, side by side.
        </p>
        <Button size="sm" className="mt-1">
          Get your quotes
        </Button>
      </div>
    </div>
  )
}
